import { on, reducer } from "ts-action";
import { Colors } from "../types";
import { restoreDefaultColors, setColors } from "../actionCreators";
import { DEFAULT_COLORS } from "../../../config/constants";

type State = Colors | null;
const initialState: State = null;

const colorsReducer = reducer<State>(
  initialState,
  on(setColors, (state, { payload: { newColors } }) => ({ ...newColors })),
  on(restoreDefaultColors, (state, action) => ({ ...DEFAULT_COLORS }))
);

export default colorsReducer;
